import { makeStyles } from '@material-ui/core/styles';

export const useImageGalleryStyles = makeStyles(theme => ({
  gallery: {}
}));
